import CrudController from "./crud_controller";

export default class extends CrudController {
  connect() {
    this.siteNum = this.data.get("siteNum");
    this.contactNum = this.data.get("contactNum");
    this.loadList();
  }

  loadList() {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/contacts/${this.contactNum}/emails`), this.listTarget)
      .then(() => {
        if(window.App.EDIT_MODE) this.showNewLink();
      });
  }

  new(event) {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/contacts/${this.contactNum}/emails/new`), this.listTarget)
      .then(() => {
        this.hideNewLink();
      });
  }

  edit(event) {
     let div = document.createElement("div");
      div.classList.add("circle-loader");

    let button = event.target.closest("button");

    button.replaceWith(div);
    this.clearMessage();
    let seqNum = event.currentTarget.dataset.seqNum;
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/contacts/${this.contactNum}/emails/${seqNum}/edit`), this.listTarget)
      .then(() => {
        this.hideNewLink();
         div.replaceWith(button);

      });
  }
}